/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferBatchesControllerAddCustomersToBatchMutationRequest, TransferBatchesControllerAddCustomersToBatchMutationResponse, TransferBatchesControllerAddCustomersToBatchPathParams, TransferBatchesControllerAddCustomersToBatch400, TransferBatchesControllerAddCustomersToBatch401, TransferBatchesControllerAddCustomersToBatch403, TransferBatchesControllerAddCustomersToBatch404 } from "../../models/transferBatchesController/TransferBatchesControllerAddCustomersToBatch";

function getTransferBatchesControllerAddCustomersToBatchUrl(id: TransferBatchesControllerAddCustomersToBatchPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/transfer-batches/${id}/customers` as const }  
  return res
}

/**
 * @summary Add customers to a transfer batch
 * {@link /api/v1/transfer-batches/:id/customers}
 */
export async function transferBatchesControllerAddCustomersToBatch(id: TransferBatchesControllerAddCustomersToBatchPathParams["id"], data?: TransferBatchesControllerAddCustomersToBatchMutationRequest, config: Partial<RequestConfig<TransferBatchesControllerAddCustomersToBatchMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TransferBatchesControllerAddCustomersToBatchMutationResponse, ResponseErrorConfig<TransferBatchesControllerAddCustomersToBatch400 | TransferBatchesControllerAddCustomersToBatch401 | TransferBatchesControllerAddCustomersToBatch403 | TransferBatchesControllerAddCustomersToBatch404>, TransferBatchesControllerAddCustomersToBatchMutationRequest>({ method : "POST", url : getTransferBatchesControllerAddCustomersToBatchUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}